import { instance, instanceWithAuth } from '@/api/index';

const AUTH_PATH = '/auth';

function login(userData) {
	return instance.post(AUTH_PATH + '/login', userData, { withCredentials: true });
}

function loginDnb(userData) {
	return instance.post(AUTH_PATH + '/login-dnb', userData, { withCredentials: true });
}

function autoLogin() {
	return instance.post(AUTH_PATH + '/login-auto', { withCredentials: true });
}

function refresh(accessToken) {
	return instanceWithAuth.get(AUTH_PATH + '/refresh?accessToken=' + accessToken);
}

export { login, loginDnb, autoLogin, refresh };
